import { Button, Box, Typography, Paper, CardMedia } from "@mui/material";
import { AppColor } from '../../../../types/Constants';
import ArrowSVG  from "./vectors/Arrow.svg";
import Arrow2SVG from "./vectors/Arrow2.svg";
import Arrow3SVG from "./vectors/Arrow3.svg";

const TutorialPage = () => {

    return (
        <Box sx={{ display: "flex", width: "100%", gap: 4, mt: 10 }}>
            <Paper sx={{ backgroundColor: "white", width: "50%", }}>
                <Box sx={{ display: "flex", gap: 10, padding: 4, zIndex: 2 }}>
                    <Box sx={{ width: "40%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Box sx={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center",
                        position: "relative",
                        gap: 0,
                        zIndex: 10
                    }}>
                    <img src={Arrow2SVG} style={{ width: "8vw", position: "absolute", transform: "translateX(-50%)", top: "-60px"}}/>
                        <CardMedia 
                            component="img" 
                            image="/images/tutorial/button.png"
                            sx={{ 
                                marginTop: 8,
                                marginBottom: 2,
                                width: "70%",
                             }}
                        />
                        <img src={ArrowSVG} width="30vw"/>
                        </Box>
                    </Box>
                    <Box sx={{ width: "60%", zIndex: 3 }}>
                        <Typography sx={{ color: AppColor.darkBrand, fontSize: 20, fontWeight: 600, mb: 2 }}>Create an AR Experience</Typography>
                        <Typography sx={{ fontSize: 16, fontWeight: 500 }}>To create your first AR Experience, click the + New Experience button here.<br /><br />You will then enter an Experience Name as well as a unique Identifier for the URL where your Experience will live.</Typography>
                    </Box>
                </Box>
                <Box sx={{ width: "100%", position: "relative", zIndex: 1, height:"200px" }}>
                    <CardMedia
                        component="img" 
                        image="/images/tutorial/experience.png"
                        sx={{ 
                            width: "70%",
                            position: "absolute",
                            top:"-45px",
                            left: "38%",
                            transform: "translateX(-50%)",
                            zIndex: -1,

                         }}
                    />
                </Box>
            </Paper>
            <Paper sx={{ backgroundColor: "white", width: "50%" }}>
                <Box sx={{ display: "flex", gap: 2, padding: 4 }}>
                    <Box sx={{ width: "50%" }}>
                        <Typography sx={{ color: AppColor.darkBrand, fontSize: 20, fontWeight: 600, mb: 2 }}>Manage Your Account</Typography>
                        <Typography sx={{ fontSize: 16, fontWeight: 500 }}>First, make sure you have started your trial, or select a subscription tier.<br /><br />You will need to have an active plan to create and manage your AR Experiences.<br /><br />You can also change your password, or log out through the Account pulldown.</Typography>
                    </Box>
                    <Box sx={{ 
                        display: "flex", 
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        width: "50%",
                    }}>
                    <CardMedia
                        component="img" 
                        image="/images/tutorial/account.png"
                        sx={{ 
                            width: "80%",
                            minWidth: "50%",
                         }}
                    />
                    <img src={Arrow3SVG} 
                        style={{ 
                            width: "5%",
                            position: "fixed", 
                            top: "10%", 
                            right: "10px",
                            transform: "translate(0, 0)"
                        }}
                    />
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default TutorialPage;
